/* TealerLab Menu Drawer — JS controller (drill-down navigation) */
(function () {
  const dlg = document.getElementById('tlr-menu-drawer');
  if (!dlg) return;

  const rootPanel = dlg.querySelector('.tlr-menu__panel--root');

  function resetPanels() {
    rootPanel?.classList.remove('is-drilled');
    dlg.querySelectorAll('.tlr-menu__panel.is-active').forEach(p => p.classList.remove('is-active'));
    dlg.querySelectorAll('[data-tlr-drill]').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
  }

  // overflow:hidden sur html + body — iOS 15.4+ le supporte sans position:fixed.
  // Pas de position:fixed → pas de scroll-to-top à la fermeture.
  function lockScroll() {
    // Measured BEFORE hiding overflow: 0 with overlay scrollbars, the real
    // gutter with classic ones — the CSS compensation reads it.
    const sb = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--tlr-sb-comp', sb + 'px');
    document.documentElement.classList.add('tlr-scroll-locked');
    document.body.classList.add('tlr-menu-open');
  }
  function unlockScroll() {
    document.documentElement.classList.remove('tlr-scroll-locked');
    document.body.classList.remove('tlr-menu-open');
  }

  window.tlrOpenMenu = function () {
    // Ferme le drawer natif Horizon si ouvert
    document.querySelectorAll('header-drawer details[open], details.menu-drawer-container[open]').forEach(d => {
      try { d.removeAttribute('open'); } catch (_) {}
    });
    resetPanels(); // toujours démarre au root
    if (!dlg.open) {
      try { dlg.showModal(); } catch (_) { dlg.setAttribute('open', ''); }
    }
    lockScroll();
    // iOS Safari fix : showModal() piège le focus → premier tap = focus, second = click.
    // On focus le dialog immédiatement pour que le premier tap soit déjà un vrai click.
    requestAnimationFrame(() => dlg.focus());
  };

  window.tlrCloseMenu = function () {
    if (!dlg.open) return;
    if (dlg.classList.contains('is-closing')) return;
    dlg.classList.add('is-closing');
    setTimeout(() => {
      dlg.classList.remove('is-closing');
      try { dlg.close(); } catch (_) { dlg.removeAttribute('open'); }
      unlockScroll();
      resetPanels();
    }, 320);
  };

  // Failsafe : ESC natif ou backdrop natif
  dlg.addEventListener('close', () => {
    unlockScroll();
    resetPanels();
  });

  // Bouton croix
  dlg.querySelectorAll('[data-tlr-menu-close]').forEach(el => {
    el.addEventListener('click', window.tlrCloseMenu);
  });

  // Ferme si clic sur le backdrop (clic direct sur le dialog, pas un enfant)
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) window.tlrCloseMenu();
  });

  dlg.querySelectorAll('[data-tlr-drill]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panelId = btn.dataset.tlrDrill;
      const subPanel = dlg.querySelector('#' + panelId);
      if (!subPanel) return;
      rootPanel?.classList.add('is-drilled');
      subPanel.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      // Focus le premier élément interactif du sous-panel après l'animation
      setTimeout(() => subPanel.querySelector('button, a')?.focus(), 300);
    });
  });

  function goBack(subPanel) {
    if (!subPanel) return;
    subPanel.classList.remove('is-active');
    rootPanel?.classList.remove('is-drilled');
    dlg.querySelector(`[data-tlr-drill="${subPanel.id}"]`)?.setAttribute('aria-expanded', 'false');
  }

  dlg.querySelectorAll('[data-tlr-back]').forEach(btn => {
    btn.addEventListener('click', () => goBack(btn.closest('.tlr-menu__panel')));
  });

  let _swipeX = 0;
  dlg.addEventListener('touchstart', (e) => { _swipeX = e.touches[0].clientX; }, { passive: true });
  dlg.addEventListener('touchend', (e) => {
    const delta = e.changedTouches[0].clientX - _swipeX;
    if (delta > 60) { // 60px vers la droite = retour
      const activePanel = dlg.querySelector('.tlr-menu__panel.is-active');
      if (activePanel) goBack(activePanel);
    }
  }, { passive: true });

  function bindBurger() {
    const burgers = document.querySelectorAll(
      'header-drawer > details.menu-drawer-container > summary, header-component header-drawer summary'
    );
    burgers.forEach(burger => {
      if (burger._tlrBound) return;
      burger._tlrBound = true;
      burger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.tlrOpenMenu();
      }, true); // capture phase pour intercepter avant Horizon
    });
  }
  bindBurger();
  // Re-bind si Horizon re-render le DOM
  new MutationObserver(bindBurger).observe(document.body, { childList: true, subtree: true });

  // Ferme sur clic de lien (navigation vers une page)
  dlg.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', () => setTimeout(() => window.tlrCloseMenu(), 50));
  });

  const countdownEl = dlg.querySelector('[data-tlr-op-countdown]');
  if (countdownEl) {
    const target = new Date(countdownEl.getAttribute('data-tlr-op-countdown')).getTime();
    if (!isNaN(target)) {
      const dEl = countdownEl.querySelector('[data-d]');
      const hEl = countdownEl.querySelector('[data-h]');
      const mEl = countdownEl.querySelector('[data-m]');
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) { countdownEl.style.display = 'none'; return; }
        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
      };
      tick();
      setInterval(tick, 60000);
    }
  }
})();
